import React from 'react';
import classNames from 'classnames';
import ListingOptionCard from './components/ListingOptionCard';
import { FieldRenderProps } from 'react-final-form';
import { ListingPackage } from 'models/Listing';

import './ListingOptionCardField.styles.scss';

type ListingOptionCardFieldProps = {
  className?: string;
  options: ListingPackage[];
  brokerLogo?: string;
  brokerAvatar?: string;
  customOnChange?: (option: ListingPackage) => void;
} & FieldRenderProps<string, HTMLElement>;

const ListingOptionCardField: React.FC<ListingOptionCardFieldProps> = (
  props,
) => {
  const {
    className,
    options,
    brokerAvatar,
    brokerLogo,
    input: { value, onChange },
    customOnChange,
  } = props;

  const classes = classNames('listing-option-card-field', className);

  return (
    <div className={classes}>
      {options.map((option) => (
        <ListingOptionCard
          key={option}
          option={option}
          isSelected={value === option}
          brokerAvatar={brokerAvatar}
          brokerLogo={brokerLogo}
          onClick={() => {
            onChange(option);
            customOnChange?.(option);
          }}
        />
      ))}
    </div>
  );
};

export default ListingOptionCardField;
